import React, { useState } from 'react';
import { FaCheck, FaPen, FaTrash } from 'react-icons/fa';

function ResultsTable({ games, handleScoreChange, handleScoreUpdate, handleDelete, showButtons = true }) {
  const [editingGameId, setEditingGameId] = useState(null);

  const handleEdit = (gameId) => {
    setEditingGameId(gameId);
  };

  const handleCancel = () => {
    setEditingGameId(null);
  };

  const handleSave = (gameId) => {
    handleScoreUpdate(gameId);
    setEditingGameId(null);
  };

  return (
    <table className="results-table">
      <tbody>
        {games.map((game) => (
          <tr key={game.id}>
            {editingGameId === game.id ? (
              <>
                <td data-label="Home" className="mobile-hide">{game.homeTeam.name}</td>
                <td data-label="Match" className="mobile-show">
                  <div className="mobile-stack">{game.homeTeam.name} vs {game.awayTeam.name}</div>
                </td>
                <td data-label="Home Score" className="mobile-hide">
                  <input
                    type="number"
                    style={{ width: '50px' }}
                    defaultValue={game.home_score}
                    onChange={(e) => handleScoreChange(game.id, 'home', e.target.value)}
                  />
                </td>
                <td className="mobile-hide">vs</td>
                <td data-label="Away Score" className="mobile-hide">
                  <input
                    type="number"
                    style={{ width: '50px' }}
                    defaultValue={game.away_score}
                    onChange={(e) => handleScoreChange(game.id, 'away', e.target.value)}
                  />
                </td>
                <td className="mobile-hide">{game.awayTeam.name}</td>
                <td data-label="Score" className="mobile-show">
                  <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', justifyContent: 'center' }}>
                    <input
                      type="number"
                      style={{ width: '50px' }}
                      defaultValue={game.home_score}
                      onChange={(e) => handleScoreChange(game.id, 'home', e.target.value)}
                    />
                    <span>-</span>
                    <input
                      type="number"
                      style={{ width: '50px' }}
                      defaultValue={game.away_score}
                      onChange={(e) => handleScoreChange(game.id, 'away', e.target.value)}
                    />
                  </div>
                </td>
                <td data-label="Actions">
                  <div className="table-actions">
                    <button onClick={() => handleSave(game.id)} className="submit icon-btn"><FaCheck /></button>
                    <button onClick={handleCancel} className="icon-btn">Cancel</button>
                  </div>
                </td>
              </>
            ) : (
              <>
                <td data-label="Match">{game.homeTeam.name} - {game.awayTeam.name}</td>
                <td data-label="Score">{game.home_score} - {game.away_score}</td>
                {showButtons && (
                  <td data-label="Actions">
                    <div className="table-actions">
                      <button onClick={() => handleEdit(game.id)} className="icon-btn"><FaPen /></button>
                      <button onClick={() => handleDelete(game.id)} className="danger icon-btn"><FaTrash /></button>
                    </div>
                  </td>
                )}
              </>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default ResultsTable;
